<!--page starts-->
<section class="page-wrapper">
    <div class="live-score-top-section margin-top-152 cf">
        <div class="container" *ngIf="iframeurl != ''">
            <!-- <div class="live-score-top-detail">
                <div class="live-score-top-detail-inner">
                    <div class="live-score-top-team-name">
                        <div class="live-score-top-team-name-left">
                            <h2>LEICESTERSHIRE</h2>
                        </div>
                        <div class="live-score-top-team-vs-center">
                            <h3>vs</h3>
                        </div>
                        <div class="live-score-top-team-name-right">
                            <h2>LANCASHIRE</h2>
                        </div>
                    </div>
                    <div class="live-score-top-ground-name">
                        <p>North Group, Manchester, Sep 20 2020, Vitality Blast</p>
                    </div>
                    <div class="live-score-top-won-team-name">
                        <h4>Leicestershire  won by 22 runs</h4>
                    </div>
                </div>
            </div>
            <div class="live-score-top-team-icon-setion cf">
                <div class="live-score-top-team-icon">
                    <div class="live-score-top-team-icon-left">
                        <img src="assets/images/Bitmap.png">
                        <div class="team-win-icon"></div>
                    </div>
                    <div class="live-score-top-team-icon-right">
                        <img src="assets/images/Bitmap-one.png">
                    </div>
                </div>
            </div> -->
            <!--<iframe scrolling="no" width="100%" height="100%"  [src]="urlSafe" title="description"></iframe>-->
            <link rel="stylesheet" type="text/css" href="https://widgets.nvplay.com/2.0/css/widgets.nvplay.css">
            <div id="nvplay-data"></div>
        </div>
    </div>
    <!-- <div class="live-score-bottom-section cf">
        <div class="container">
            <div class="live-scorecard-summary-detail">
                <div class="live-scorecard-summary-top">
                    <div class="live-scorecard-summary-top-left">
                        <h2>Scorecard Summary</h2>
                    </div>
                    <div class="live-scorecard-summary-top-btn">
                        <a href="javascript:void(0)">WATCH HIGHLIGHT</a>
                    </div>
                </div>
                <div class="live-scorecard-summary-bottom">
                    <div class="live-scorecard-summary-bottom-left">
                        <div class="live-scorecard-summary-bottom-left-top win-team">
                            <div class="live-scorecard-summary-icon">
                                <div class="live-scorecard-icon">
                                    <img src="assets/images/Bitmap.png">
                                </div>
                            </div>
                            <div class="live-scorecard-summary-team-name">
                                <h2>Leicestershire </h2>
                            </div>
                            <div class="live-scorecard-summary-over">
                                
                            </div>
                            <div class="live-scorecard-summary-run">
                                <h2>154/3</h2>
                            </div>
                        </div>
                        <div class="live-scorecard-summary-bottom-left-top">
                            <div class="live-scorecard-summary-icon">
                                <div class="live-scorecard-icon">
                                    <img src="assets/images/Bitmap-one.png">
                                </div>
                            </div>
                            <div class="live-scorecard-summary-team-name">
                                <h2>Leicestershire </h2>
                            </div>
                            <div class="live-scorecard-summary-over">
                                <p>(20 ov, target 155)</p>
                            </div>
                            <div class="live-scorecard-summary-run">
                                <h2>154/3</h2>
                            </div>
                        </div>
                    </div>
                    <div class="live-scorecard-summary-bottom-right">
                        <div class="live-scorecard-summary-bottom-content">
                            <p>PLAYER OF THE MATCH</p>
                            <h3>Colin Ackermann</h3>
                            <span>Leicestershire</span>
                        </div>
                    </div>
                </div>
                <div class="live-scorecard-summary-tab-section cf">
                    <div class="live-scorecard-summary-tab">
                        <ul>
                            <li class="courses-name active " id="commentary"><a href="#">Commentary</a></li>
                            <li class="courses-name " id="scorecard"><a href="#">Scorecard</a></li>
                        </ul>
                    </div>
                    <div class="live-scorecard-summary-tab-content course-main-content active cf" id="commentary-content">
                        <div class="live-scorecard-commentary-top">
                            <div class="live-commentary-player-detail-left-team">
                               <h2>Leicestershire </h2> 
                               <div class="live-commentary-player-detail-box">
                                    <div class="live-commentary-player-batting">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Arron L.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>49<span>(41)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Nick W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>43<span>(36)</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="live-commentary-player-bowling">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Luke W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/5<span>(3)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Matt P.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/30<span>(4)</span></p>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                            <div class="live-commentary-player-detail-right-team">
                                <h2>Nottinghamshire </h2> 
                               <div class="live-commentary-player-detail-box">
                                    <div class="live-commentary-player-batting">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Arron L.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>49<span>(41)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Nick W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>43<span>(36)</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="live-commentary-player-bowling">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Luke W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/5<span>(3)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Matt P.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/30<span>(4)</span></p>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </div>
                        <div class="live-commentary-detail">
                            <ul>
                                <li>
                                  <p><span class="over">12.4</span>
                                  <span class="run">4</span>
                                  <span class="text">Griffiths to Lamb, 1 leg bye Yorker at leg stump, squeezed out towards long-on</span>
                                </p>
                                </li>
                                <li>
                                  <p><span class="over">12.3</span>
                                  <span class="run">6</span>
                                  <span class="text">Griffiths to Jones, 6 run, Pulled neatly to deep square's right. Short ball sitting up at middle stump, nicely in position and hits it along the ground</span></p>
                                </li>
                                <li>
                                  <p><span class="over">12.2</span>
                                  <span class="run">6</span>
                                  <span class="text">Griffiths to Jones, 6 run, Pumped past the bowler. Slower ball at a length wide outside off, slides on nicely as he gets forward. Slapped on the rise ad long-off has no chance to the left</span></p>
                                </li>
                                <li>
                                  <p><span class="over">12.1</span>
                                  <span class="run">4</span>
                                  <span class="text">Griffiths to Jones, 4 run, Lofted over the bowler. Low full toss at off stump, gets low with the front leg away and lifts it</span></p>
                                </li>
                                <li>
                                  <p><span class="over">11.6</span>
                                  <span class="run">1</span>
                                  <span class="text">Griffiths to Lamb, 1 run, Looks for the reverse ramp after shaping for the conventional ramp.</span></p>
                                </li> 
                                <li>
                                  <p><span class="over">11.5</span>
                                  <span class="run">0</span>
                                  <span class="text">Griffiths to Jones, 0 run, Beaten by a friendly full toss. Loses his shape and smiles sheepishly.</span></p>
                                </li>
                            </ul>
                            <a href="#" class="full-commentary-btn">Read Full Commentry</a>
                        </div>
                    </div>
                    <div class="live-scorecard-summary-tab-content course-main-content cf" id="scorecard-content">
                        <div class="live-scorecard-commentary-top">
                            <div class="live-commentary-player-detail-left-team">
                               <h2>Leicestershire </h2> 
                               <div class="live-commentary-player-detail-box">
                                    <div class="live-commentary-player-batting">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Arron L.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>49<span>(41)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Nick W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>43<span>(36)</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="live-commentary-player-bowling">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Luke W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/5<span>(3)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Matt P.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/30<span>(4)</span></p>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                            <div class="live-commentary-player-detail-right-team">
                                <h2>Nottinghamshire </h2> 
                               <div class="live-commentary-player-detail-box">
                                    <div class="live-commentary-player-batting">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Arron L.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>49<span>(41)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Nick W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>43<span>(36)</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="live-commentary-player-bowling">
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Luke W.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/5<span>(3)</span></p>
                                            </div>
                                        </div>
                                        <div class="live-commentary-player-box">
                                            <div class="live-commentary-player-image">
                                                <a href="#"><img src="assets/images/playe-img.png"></a>
                                            </div>
                                            <div class="live-commentary-player-name">
                                                <h3>Matt P.</h3>
                                            </div>
                                            <div class="live-commentary-player-run">
                                                <p>1/30<span>(4)</span></p>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </div>
                        <div class="live-scorecard-commentary-bottom cf">
                            <div class="live-scorecard-detail cf">
                                <div class="scorecard-team-one cf">
                                   <div class="scorecard-titel open">Leicestershire <span>1st Innings</span> <a href="#" class="up-right-live-match"></a></div>
                                   <div class="live-scorecard-team-one up cf">
                                      <table class="batsman" cellpadding="0" cellspacing="0">
                                         <tr class="titel">
                                            <th>Batsman</th>
                                            <th></th>
                                            <th>R</th>
                                            <th>B</th>
                                            <th>4s</th>
                                            <th>6s</th>
                                            <th>SR</th>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td>NR Welch </td>
                                            <td>c Bohannon b Livingstone</td>
                                            <td>32</td>
                                            <td>12</td>
                                            <td>05</td>
                                            <td>00</td>
                                            <td>200.00</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td>GJ Delany  </td>
                                            <td>c †Davies b Wood</td>
                                            <td>22</td>
                                            <td>20</td>
                                            <td>04</td>
                                            <td>00</td>
                                            <td>102.32</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td>AM Lilley </td>
                                            <td>c †Davies b Parkinson</td>
                                            <td>12</td>
                                            <td>12</td>
                                            <td>01</td>
                                            <td>00</td>
                                            <td>100.00</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td class="play">HJ Swindells †</td>
                                            <td class="play">not out</td>
                                            <td>12</td>
                                            <td>12</td>
                                            <td>01</td>
                                            <td>00</td>
                                            <td>100.00</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td class="play">LJ Hill </td>
                                            <td class="play">not out</td>
                                            <td>38</td>
                                            <td>08</td>
                                            <td>00</td>
                                            <td>06</td>
                                            <td>102.32</td>
                                         </tr>
                                         <tr class="extra">
                                            <td><p>Extra:<span>(nb 0, w 3, b 0, lb 0)</span></p></td>
                                            <td class="total-extra">03</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                         </tr>
                                         <tr class="total">
                                            <td>Total</td>
                                            <td>3 Wicket</td>
                                            <td>154/5</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                         </tr>
                                      </table>
                                      <table class="bowler">
                                         <tr class="titel">
                                            <th>Bowler</th>
                                            <th></th>
                                            <th>O</th>
                                            <th>M</th>
                                            <th>R</th>
                                            <th>W</th>
                                            <th>Eco</th>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>L Wood</td>
                                            <td></td>
                                            <td>2.4</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>S Mahmood</td>
                                            <td></td>
                                            <td>03</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>DJ Lamb</td>
                                            <td></td>
                                            <td>01</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>TW Hartley</td>
                                            <td></td>
                                            <td>02</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                      </table>
                                   </div>
                                </div>
                                <div class="scorecard-team-two cf">
                                   <div class="scorecard-titel">Leicestershire <span>2nd Innings</span> <a href="#" class="up-arrow-live-match"></a></div>
                                   <div class="live-scorecard-team-two cf">
                                      <table class="batsman" cellpadding="0" cellspacing="0">
                                         <tr class="titel">
                                            <th>Batsman</th>
                                            <th></th>
                                            <th>R</th>
                                            <th>B</th>
                                            <th>4s</th>
                                            <th>6s</th>
                                            <th>SR</th>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>NR Welch </td>
                                            <td>c Bohannon b Livingstone</td>
                                            <td>32</td>
                                            <td>12</td>
                                            <td>05</td>
                                            <td>00</td>
                                            <td>200</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td>GJ Delany  </td>
                                            <td>c †Davies b Wood</td>
                                            <td>22</td>
                                            <td>20</td>
                                            <td>04</td>
                                            <td>00</td>
                                            <td>102.32</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td>AM Lilley </td>
                                            <td>c †Davies b Parkinson</td>
                                            <td>12</td>
                                            <td>12</td>
                                            <td>01</td>
                                            <td>00</td>
                                            <td>100.00</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td class="play">HJ Swindells †</td>
                                            <td class="play">not out</td>
                                            <td>12</td>
                                            <td>12</td>
                                            <td>01</td>
                                            <td>00</td>
                                            <td>100.00</td>
                                         </tr>
                                         <tr class="white-bg border-top">
                                            <td class="play">LJ Hill </td>
                                            <td class="play">not out</td>
                                            <td>38</td>
                                            <td>08</td>
                                            <td>00</td>
                                            <td>06</td>
                                            <td>102.32</td>
                                         </tr>
                                         <tr class="extra">
                                            <td><p>Extra:<span>(nb 0, w 3, b 0, lb 0)</span></p></td>
                                            <td class="total-extra">03</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                         </tr>
                                         <tr class="total">
                                            <td>Total</td>
                                            <td>3 Wicket</td>
                                            <td>154/5</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                         </tr>
                                      </table>
                                      <table class="bowler">
                                         <tr class="titel">
                                            <th>Bowler</th>
                                            <th></th>
                                            <th>O</th>
                                            <th>M</th>
                                            <th>R</th>
                                            <th>W</th>
                                            <th>Eco</th>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>L Wood</td>
                                            <td></td>
                                            <td>2.4</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>S Mahmood</td>
                                            <td></td>
                                            <td>03</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>DJ Lamb</td>
                                            <td></td>
                                            <td>01</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                         <tr class="white-bg">
                                            <td>TW Hartley</td>
                                            <td></td>
                                            <td>02</td>
                                            <td>0</td>
                                            <td>30</td>
                                            <td>01</td>
                                            <td>8.21</td>
                                         </tr>
                                      </table>
                                   </div>
                                </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</section><!-- page ends-->